export default {
  namespaced: true,
  state: {
    display: false,
    fromLogin: undefined,
  },
  getters: {
    // ライセンス入力画面表示フラグ
    display: state => state.display,
    fromLogin: state => state.fromLogin,
  },
  mutations: {
    setDisplay(state, display) {
      state.display = display
    },
    setFromLogin(state, fromLogin) {
      state.fromLogin = fromLogin
    },
  },
  actions: {
    show(context, fromLogin){ 
      context.commit("setFromLogin", fromLogin)
      context.commit("setDisplay", true)
    },
    hide(context){ 
      context.commit("setDisplay", false)
      context.commit("setFromLogin", undefined)
    },
  },
}
